import { useMemo } from 'react';
import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import {
  type FetchWantedTimesParams,
  type FetchWantedTimesResponse,
} from '@order/features/ordering';

import {
  BagTimesPollingDocument,
  type BagTimesPollingQuery,
} from '../../GraphQL/BagTimesPolling.generated';
import { mapWantedTimes } from '../../utils/wantedTimes';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching wanted times for use in machine polling.
 */
export const useFetchWantedTimes = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchWantedTimes = useMemo(
    () =>
      fromPromise<FetchWantedTimesResponse, FetchWantedTimesParams>(
        async () => {
          const queryRewards = client.query<BagTimesPollingQuery>;

          const response = await queryRewards(
            BagTimesPollingDocument,
            {},
            { requestPolicy: 'network-only' },
          ).toPromise();

          const availableTimes =
            response.data?.cart?.availableWantedTimes ?? [];
          const wantedTimes = mapWantedTimes(availableTimes);

          return { wantedTimes };
        },
      ),
    [client.query],
  );

  return { fetchWantedTimes };
};
